import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../constantes/constantes.service';
import { Observable } from 'rxjs/Observable';
import { ActivoOculto } from '../modelos/activo_oculto';

@Injectable()
export class ActivosOcultosService {

    constructor(private http: HttpClient, private constantes: ConstantesService) { }

    getActivosOcultos(id): Observable<any> {
        return this.http.get<ActivoOculto[]>(environment.urlBase + 'hidden_assets/'+id, this.constantes.httpOptions);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/activos-ocultos.service.ts